import React, { ReactNode } from 'react';
import { useEditFormFieldsBasic } from '../../../toolympus/components/ConfigurableForms/useEditConfigurableForm';
import { Dialog, DialogState, FormGrid } from '../../../toolympus/components/primitives';
import { Schema } from '../../../toolympus/hooks/useSchema';
import { CustomFieldType, FormFieldsEditor } from '../../../toolympus/components/ConfigurableForms/FormFieldsEditor';
import { Button, Divider, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { FormControlsForFields } from '../../../toolympus/components/schemed';
import { AttendeeProfileConfigurationData } from './useAttendeeProfileConfiguration';

interface Props {
  
}


interface Props extends Omit<DialogState, "open"> {
  data: AttendeeProfileConfigurationData;
  title: ReactNode;
  hint?: ReactNode;
}

const ApplicationConfigSchema: Schema = {
  display_name_format: { label: "Display name format" },
}


const CustomFieldTypes: CustomFieldType[] = [
  // { value: TopicsFieldType, },
]

export const AttendeeProfileConfigurationDialog = (props: Props) => {
  const fieldsData = useEditFormFieldsBasic(props.data);
  return (
    <Dialog
      dialogTitle={props.title}
      closeButtonTop
      isOpen={props.isOpen}
      close={() => { props.close(); props.data.reload(); }}
      maxWidth="md"
      actions={
        <Button color="primary" variant="contained" onClick={() => { props.data.save().then(() => props.close()); }}>
          <FormattedMessage id="common.save" />
        </Button>
      }>
      <FormGrid columns="1fr">
        {props.hint}

        <FormControlsForFields
          fields={[
            ["display_name_format"],
          ]}
          schema={ApplicationConfigSchema}
          data={props.data.data}
          onChange={(o,c) => props.data.update(c)}
          />

        <div />

        <Divider />

        <Typography>Fields</Typography>

        <FormFieldsEditor
          data={fieldsData}
          customFieldTypes={CustomFieldTypes}
          noRegexes
          allowSubtypes
          />

      </FormGrid>
    </Dialog>
  );
}
